import React from "react";
import {Grid, Tab, Tabs, TextField, Typography, MenuItem, Button, InputAdornment, Hidden, Box} from "@material-ui/core";
import {Launch} from "@material-ui/icons";
import Widget from "../../../components/BetterWidget";
import ProgressOr from "../../../components/ProgressOr";
import Rest from "../../../helpers/Rest";
import {Customers} from "../../../context/CustomersContext";
import DeviceStatus from "./DeviceStatus/DeviceStatus";
import {useTheme} from "@material-ui/core";
import useStyles from "./styles"
import DeviceEvents from "./DeviceEvents/DeviceEvents";
import Credentials from "./Credentials";
import {Devices} from "../../../context/DevicesContext";
import {columnOffsets, deviceTypes, getDeviceType} from "../Config";
import {deviceIcons, DeviceIcon, getDefaultIcon} from "../../../components/DeviceIcon"
import Connection from "./Connection/Connection";
import Configuration from "./Configuration/Configuration";
import {Components, fetchComponents, mapCompletedTests} from "./Components/Components";
import {getDevicePhotos, ImagesButton} from "./ImageDialog/ImagesButton";
import {Warning} from "@material-ui/icons";
import QRCodeScanner from "../components/QRCodeScanner";
import QRCodeIcon from "./QRCodeIcon";
import clsx from "clsx";
import ViewHistoryButton from "./ViewHistoryButton";
import CheckListDialog from "./CheckListDialog";
import ReplaceMasterDialog from "./ReplaceMasterDialog";
import Monitor from "./Monitor";
import { DocumentList } from "./Documents/Documents";
import { DocumentsProvider } from "./Documents/DocumentsContext";
import UploadDocumentButton from "./Documents/UploadDocumentButton";

const END_POINT = 'device', PROPERTIES = [
    "id", "code", "device_type", "serial",
    "qr_code", "name", "notes", "customer_id",
    "site_id", "last_reported", "status",
    "sw_version", "hw_version", "icon",
    "vehicle", "test_status", "monitored",
    "offline_alert"
], REQUIRES_TEST = ["site_id", "customer_id"]

const {ID, SERIAL, QR_CODE, VEHICLE} = columnOffsets;
const TESTED = "tested", UNTESTED = "untested", NEW = "new"

const SOUNDER_TYPES = (() => {
    const num = 16
    const out = new Array(num)
    for (let i = 0; i < num; ++i){
        out[i] = `Position ${i}`
    }
    return out
})()

const COMPONENT_TYPES = deviceTypes.map(type => type.value)

function Block({hidden, children, className, heading, fullWidth}) {
    const classes = useStyles(useTheme())
    if (hidden){
        return null;
    }
    return (
        <Grid item xs={12} sm={fullWidth ? undefined : 6} className={clsx(classes.block, className)}>
            <Typography variant="h3">{heading}</Typography>
            {children}
        </Grid>
    )
}

function TabPanel(props){
    return (
        <Grid container spacing={2} style={{display: props.hidden ? 'none' : 'flex'}} justify="center" {...props}/>
    )
}

function ClampedTextField({className, ...props}) {
    const classes = useStyles(useTheme())
    return (
        <TextField
            variant="outlined"
            fullWidth
            className={clsx(className, classes.textField)}
            {...props}
        />
    )
}

function QRScanTextField({onToggleQrCode, ...props}){
    const classes = useStyles(useTheme())
    return <ClampedTextField
        InputProps={{
            endAdornment: <InputAdornment position="end" onClick={onToggleQrCode} style={{
                cursor: "pointer"
            }}>
                <QRCodeIcon/>
            </InputAdornment>
        }}
        {...props}
        className={classes.qrCodeTextField}
    />
}

function createCode(deviceType, serial){
    return deviceType + serial
}

function extractParameter(name){
    console.log(`(?:^|[?&])${name}=([^&]+)`)
    console.log(window.document.location.href)
    const match = (new RegExp(`(?:^|[?&])${name}=([^&]+)`)).exec(window.document.location.href)
    console.log(match && match[1] || "no match")
    return match ? match[1] : null
}

function extractId(){
    const match = /edit-device\/(\d+)/.exec(window.location.hash);
    return match ? parseInt(match[1]) : null;
}

function addIdToPath(id){
    window.location.hash += `/${id}`
}

function createDefaultDevice(){
    const code = extractParameter("device_code")
    const type = code ? getDeviceType(code) : deviceTypes[0]
    return {
        id: extractId(),
        device_type: type.value,
        code: code || type.value,
        serial: code ? code.replace(/^[A-Z]+/, '') : '',
        name: '',
        qr_code: extractParameter("qr_code") || '',
        icon: getDefaultIcon(type),
        vehicle: '',
        monitored: false,
        offline_alert: 48
    }
}

function getDefaultCustomer(customers){
    return customers.find(customer => /sonasafe/i.test(customer.name))
    || customers.find((item) => item.sites.length > 0)
}

const IDLE = 0, SAVING = 1, LOADING = 2

function equal(a, b){
    return a && b && /\w+/.test(a) && /\w+/.test(b) && a === b
}

function sanitize(val){
    return val === null || val === undefined || val === "" ? null : val
}

class EditDevice extends React.Component{
    constructor(props) {
        super(props);
        const device = this.parseDevice()
        this.codeEdited = !!device
        this.device = device || createDefaultDevice()
        if (!this.device.test_status){
            this.device.test_status = NEW
        }
        this.edited = !(device || this.device.qr_code === '')
        const isNew = !device
        const checkExisting = isNew && (this.device.qr_code || this.device.id);
        const state = {
            isNew: isNew,
            open: 0,
            edited: this.edited,
            network: checkExisting ? LOADING : IDLE,
            codeEdited: this.codeEdited,
            scanning: false,
            replacingMaster: false,
            components: [],
            sounders: [],
            photos: [],
            vehicle: '',
            installing: false,
            postingTestResults: false
        }
        this.history = props.history
        PROPERTIES.forEach(prop => state[prop] = this.device[prop])
        this.state = state;
        this.fetchCustomers()
        if (checkExisting){
            if (this.device.id){
                this.fetchById()
            }
            else {
                this.checkForExistingDevice(this.device)
            }
        }
        this.gotQrCode = result => {
            this.setState({
                scanning: false
            })
            Rest.translateDeviceUrl(result).then(result => {
                this.qrCodeTarget(result.id, getDeviceType(result.id).value, result.qr)
            }).catch(error => {
                this.qrCodeTarget(result, null, result)
            })
        }
        this.sounderTestResults = []
        this.gotSounderTestResults = results => this.sounderTestResults = results
        this.setTested = () => this.setState({
            postingTestResults: true//this.sounderTestResults
        })
        this.cancelPostingTestResults = () => this.setState({
            postingTestResults: false
        })
        this.postedTestResults = async (testResults) => {
            await Rest.post(`${END_POINT}/${this.device.id}/test`, testResults)
            await this.save(testResults.passed)
        }
        this.setQrCode = (code, type, qr) => {
            if (type){
                this.editState({
                    qr_code: qr,
                    code: code,
                    device_type: type
                })
            }
            else{
                this.editState({
                    qr_code: code
                })
            }
        }
    }

    toggleQrCode(target){
        this.qrCodeTarget = target
        this.setState({
            scanning: !this.state.scanning
        })
    }

    loaded(device){
        this.updateDevice(device)
        if (!this.device.icon){
            this.device.icon = getDefaultIcon(this.device.device_type)
        }
        this.setState({
            isNew: false,
            network: IDLE,
            ...this.device
        })
        fetchComponents(this.device.id, 'list').then(components => this.setState({
            components: components.filter(
                component => !/^position/i.test(component.component_type)
            ),
            sounders: components.filter(
                component => /^position/i.test(component.component_type)
            )
        }))
        getDevicePhotos(this.device.id).then(photos => this.setState({
            photos: photos
        }))
    }

    fetchById(){
        this.props.devicesContext.fetchDeviceById(this.device.id).then(this.loaded.bind(this))
    }

    redirectIfVehicle(devices, qrCode){
        if (!qrCode || !/\S+/.test(qrCode)){
            return
        }
        Rest.decodeQrCode(qrCode).then(id => {
            if (devices.list.find(row => equal(row[VEHICLE], id))){
                this.props.history.replace("/app/list-devices/" + id)
            }
        })
    }

    checkForExistingDevice(current){
        return this.props.devicesContext.fetchDevices().then(devices => {
            const device = devices.list.find(row => {
                return (equal(row[SERIAL], current.serial) ||
                    equal(row[QR_CODE], current.qr_code));
            })
            if (device){
                this.loaded(device);
                return true;
            }
            else{
                this.setState({
                    network: IDLE
                })
                this.redirectIfVehicle(devices, current.qr_code)
            }
            return false;
        })
    }

    parseDevice() {
        const raw = this.props.location.state
        if (!raw){
            return raw
        }
        const device = PROPERTIES.reduce((accum, val,idx) => {
            accum[val] = raw[idx]
            return accum
        }, {})
        if (!device.icon){
            device.icon = getDefaultIcon(device.device_type)
        }
    }

    fetchCustomers() {
        this.props.customersContext.fetchCustomers().then(reply => {
            const state = {
                customers: reply
            }
            if (!this.state.customer_id) {
                const customer = getDefaultCustomer(reply.list)
                if (!customer) {
                    this.history.push('add-customer')
                    return
                }
                this.device.customer_id = state.customer_id = customer.id
                this.device.site_id = state.site_id = customer.sites[0].id
            }
            this.setState(state)
        })
    }

    editState(vals){
        vals.edited = true
        this.setState(vals)
    }

    editSerial(e){
        this.editState({serial: e.target.value})
        /*const value = e.target.value
        if (this.state.codeEdited || this.device.id){
            this.editState({serial: value})
        }
        else{
            this.editState({
                serial: value,
                code: createCode(this.state.device_type, value)
            })
        }*/
    }

    editDeviceType(e){
        this.editState({device_type: e.target.value})
        /*const value = e.target.value
        if (this.state.codeEdited || this.device.id){
            this.editState({device_type: value})
        }
        else{
            this.editState({
                device_type: value,
                code: createCode(value, this.state.serial)
            })
        }*/
    }

    editCode(e){
        this.editState({
            code: e.target.value,
            codeEdited: true
        })
    }

    editIcon(e){
        this.editState({
            icon: e.target.value
        })
    }

    detailsButtons(){
        const closeDialog = () => this.setState({
            replacingMaster: false
        })
        return <>
            <ViewHistoryButton variant="text" color="primary" deviceCode={this.device.code}>
                View History
            </ViewHistoryButton>
            <Button
                variant="text"
                color="primary"
                onClick={() => this.setState({
                    replacingMaster: true
                })}
            >
                Replace
            </Button>
            <ReplaceMasterDialog
                open={this.state.replacingMaster}
                onCancel={closeDialog}
                onComplete={device => {
                    this.props.history.push({
                        pathname: `edit-device/${device[ID]}`,
                        state: device
                    })
                    this.loaded(device)
                    closeDialog()
                }}
                devicesContext={this.props.devicesContext}
                deviceId={this.device.id}
            />
        </>
    }

    detailsHeading(){
        const heading = "Device Details"
        if (!this.device.id){
            return heading
        }
        return <>
            {heading}
            <Hidden smUp>
                <Box style={{
                    display: "flex",
                    justifyContent: "space-between",
                    margin: "0 -6px"
                }}>{this.detailsButtons()}</Box>
            </Hidden>
            <Hidden xsDown>
                {this.detailsButtons()}
            </Hidden>
        </>
    }

    basicDetails(){
        const {device_type, serial, code, qr_code} = this.state
        return (
            <Block
                heading={this.detailsHeading()}
            >
                <ClampedTextField
                    value={device_type}
                    onChange={this.editDeviceType.bind(this)}
                    disabled={!Rest.isAdmin}
                    label="Device Type"
                    select
                >
                    {deviceTypes.map(type => (
                        <MenuItem key={type.value} value={type.value}>{type.label}</MenuItem>
                    ))}
                </ClampedTextField>
                <ClampedTextField
                    value={serial}
                    onChange={this.editSerial.bind(this)}
                    disabled={!Rest.isAdmin}
                    label="Serial Number"
                />
                <ClampedTextField
                    value={code}
                    onChange={this.editCode.bind(this)}
                    disabled={!Rest.isAdmin}
                    label="Device ID"
                />
                <QRScanTextField
                    value={qr_code || ''}
                    onChange={(e) => {
                        this.editState({qr_code: e.target.value})
                    }}
                    disabled={!Rest.isAdmin}
                    label="QR Code"
                    onToggleQrCode={() => this.toggleQrCode(this.setQrCode)}
                />
                {this.scanner()}
                <ClampedTextField
                    label="Notes"
                    value={this.state.notes || ""}
                    onChange={(e) => this.editState({notes: e.target.value})}
                    disabled={!Rest.isAdmin}
                    rows={10}
                    multiline
                />
            </Block>
        )
    }

    getSites(){
        if (!this.state.customers){
            return []
        }
        if (!this.state.customer_id){
            return this.state.customers.list[0].sites
        }
        return this.state.customers.map[this.state.customer_id].sites
    }

    setCustomer(customerId) {
        this.editState({
            customer_id: customerId,
            site_id: this.state.customers.map[customerId].sites[0].id
        })
    }

    getCustomers() {
        if (!this.state.customers){
            return []
        }
        return this.state.customers.list.filter((item) => item.sites.length > 0)
    }

    scanner(){
        if (!this.state.scanning){
            return null
        }
        return <QRCodeScanner
            formats={['qr_code']}
            onResult={this.gotQrCode}
            onClose={() => this.toggleQrCode()}
        />
    }

    installPhotos(){
        const {id} = this.device
        if (!id){
            return null
        }
        const {photos} = this.state
        return <div className={this.props.classes.clampedImage}>
            <ImagesButton
                text="Install photos"
                photoType="I"
                deviceId={id}
                photos={photos}
                imageWidth={64}
                imageHeight={64}
            />
        </div>
    }

    vehicleHeading(){
        const {vehicle} = this.state
        if (vehicle == null || !/\S+/.test(vehicle)){
            return "Vehicle"
        }
        return <>
            Vehicle
            <ViewHistoryButton variant="text" color="primary" deviceCode={vehicle}>
                View Vehicle History
            </ViewHistoryButton>
        </>
    }

    vehicle(){
        const {id} = this.device
        if (!id){
            return null
        }
        const {isNew, vehicle, photos, components} = this.state
        return <Block
            hidden={isNew}
            heading={this.vehicleHeading()}
            className={this.props.classes.rightBlock}>
            <QRScanTextField
                value={vehicle || ''}
                onChange={(e) => this.editState({vehicle: e.target.value})}
                label="Vehicle ID"
                onToggleQrCode={() => this.toggleQrCode(code => this.editState({
                    vehicle: code
                }))}
            />
            <div className={this.props.classes.clampedImage}>
                <ImagesButton
                    text="Vehicle photos"
                    photoType="V"
                    deviceId={id}
                    photos={photos}
                    imageWidth={64}
                    imageHeight={64}
                />
            </div>
            <Components
                components={components}
                deviceId={id}
                onModified={async comp => {
                    this.setState({
                        components: comp
                    })
                    await this.save(false)
                }}
                title="Components"
                typeOptions={COMPONENT_TYPES}
                typeLabel="Type"
                label="component"
                className={this.props.classes.components}
            />
        </Block>
    }

    installationHeading(){
        const cancel = () => this.setState({repairing: false})
        return <>
            Installation
            <Button
                variant="text"
                color="primary"
                onClick={() => this.setState({repairing: true})}
                disabled={this.device.test_status !== TESTED}
            >
                Record Repair
            </Button>
            <CheckListDialog
                variant="repair"
                open={this.state.repairing || false}
                onCancel={cancel}
                onDone={async results => {
                    cancel();
                    await this.postedTestResults(results)
                }}
                collectTicketId
            />
        </>
    }

    installation(){
        const {isNew, name, customers, customer_id, site_id, device_type, icon} = this.state
        return (
            <Block
                hidden={isNew}
                heading={this.installationHeading()}
                className={this.props.classes.rightBlock}
            >
                <ClampedTextField
                    value={name || ''}
                    onChange={(e) => this.editState({name: e.target.value})}
                    label="Name"
                />
                <ProgressOr showProgress={!customers} progressMessage="Fetching customers...">
                    <ClampedTextField
                        value={customer_id || ''}
                        onChange={(e) => this.setCustomer(e.target.value)}
                        label="Customer"
                        disabled={!Rest.isAdmin}
                        select
                    >
                        {this.getCustomers().map(customer => (
                            <MenuItem key={customer.id} value={customer.id}>{customer.name}</MenuItem>
                        ))}
                    </ClampedTextField>
                    <ClampedTextField
                        value={site_id || ''}
                        onChange={(e) => this.editState({site_id: e.target.value})}
                        label="Site"
                        disabled={!Rest.isAdmin}
                        select
                    >
                        {this.getSites().map(site => (
                            <MenuItem key={site.id} value={site.id}>{site.name}</MenuItem>
                        ))}
                    </ClampedTextField>
                </ProgressOr>
                <ClampedTextField
                    value={icon || getDefaultIcon(device_type)}
                    onChange={this.editIcon.bind(this)}
                    label="Icon"
                    select
                >
                    {Object.keys(deviceIcons).map(lib => {
                        return Object.keys(deviceIcons[lib]).map(icon => {
                            const key = `${lib}/${icon}`
                            return <MenuItem value={key} key={key}>
                                <div className={this.props.classes.deviceIcon}>
                                    <DeviceIcon path={key}/>
                                </div>
                            </MenuItem>
                        })
                    })}
                </ClampedTextField>
                {this.installPhotos()}
            </Block>
        )
    }

    updateDevice(vals) {
        for (let i = 0, key = PROPERTIES[0]; key; key = PROPERTIES[++i]){
            this.device[key] = vals[i]
        }
        if (!this.device.test_status){
            this.device.test_status = NEW
        }
    }

    copyDeviceToArray(out){
        for (let i = 0, key = PROPERTIES[0]; key; key = PROPERTIES[++i]){
            out[i] = this.device[key]
        }
        return out
    }

    async add(){
        if (await this.checkForExistingDevice(this.state)){
            return;
        }
        const data = {
            device_type: this.state.device_type,
            serial: this.state.serial,
            code: this.state.code
        }
        if (this.state.qr_code){
            data.qr_code = this.state.qr_code
        }
        this.updateDevice(await Rest.post(END_POINT, data));
        (await this.props.devicesContext.fetchDevices()).add(
            this.copyDeviceToArray(new Array(PROPERTIES.length))
        );
        addIdToPath(this.device.id)
    }

    toJson(){
        return PROPERTIES.reduce((accum, key) => {
            accum[key] = sanitize(this.state[key]);
            return accum
        }, {})
    }

    send(json){
        return Rest.put(`${END_POINT}/${this.device.id}`, json)
    }

    async copyDeviceToCurrentArray(){
        this.copyDeviceToArray(
            (await this.props.devicesContext.fetchDevices()).map[this.device.id]
        )
    }

    async update(tested){
        const json = this.toJson()
        if (tested) {
            json.test_status = tested
        }
        this.updateDevice(await this.send(json));
        await this.copyDeviceToCurrentArray()
    }

    async save(tested) {
        const {test_status} = this.device
        if (tested === undefined){
            tested = test_status
        }
        else{
            tested = tested ? TESTED : test_status === NEW ? NEW : UNTESTED
        }
        this.setState({
            network: SAVING,
        })
        if (this.state.isNew) {
            await this.add()
        }
        else{
            if (tested) {
                this.setState({
                    test_status: tested
                })
            }
            await this.update(tested)
        }
        this.codeEdited = true
        this.edited = false
        this.setState({
            isNew: false,
            network: IDLE,
            edited: false,
            codeEdited: true
        })
    }

    cancel() {
        if (this.state.edited) {
            this.setState({
                ...this.device,
                codeEdited: this.codeEdited,
                edited: this.edited
            })
        }
        else{
            this.history.go(-1)
        }
    }

    credentials(){
        if (this.state.isNew || !(Rest.isAdmin && getDeviceType(this.device.device_type).cred)){
            return null;
        }
        return <Credentials deviceName={this.device.name} deviceId={this.device.id}/>
    }

    progressMessage(){
        switch (this.state.network){
            case SAVING:
                return this.state.isNew ? "Adding device..." : `Updating ${this.state.name}...`
            case LOADING:
                return "Loading details..."
            default:
                return ""
        }
    }

    cancelButton(fullWidth){
        return <Button variant="contained" onClick={() => this.cancel()} fullWidth={fullWidth}>Cancel</Button>
    }

    saveButton(fullWidth){
        return <Button
            variant="contained"
            color="primary"
            disabled={!(this.state.edited && /\w+/.test(this.state.code) && /\w+/.test(this.state.serial))}
            onClick={() => this.save(
                REQUIRES_TEST.find(key => this.state[key] !== this.device[key]) ? false : undefined
            )}
            fullWidth={fullWidth}
        >{this.state.isNew ? "Add" : "Update"}</Button>
    }

    /*desktopButtons(){
        let className = this.props.classes.buttons
        if (this.state.isNew){
            className += ' addDevice'
        }
        return <Grid container item xs={12} spacing={this.state.isNew ? 2 : 0} justify="center">
            <Grid item xs={12} className={className}>
                {this.credentials()}
                {this.viewHistoryButton()}
                {this.cancelButton()}
                {this.saveButton()}
            </Grid>
        </Grid>
    }

    mobileButtons(){
        return <>
            <Grid item xs={6}>
                {this.credentials(true)}
            </Grid>
            <Grid item xs={6}>
                {this.viewHistoryButton(true)}
            </Grid>
            <Grid item xs={6}>
                {this.cancelButton(true)}
            </Grid>
            <Grid item xs={6}>
                {this.saveButton(true)}
            </Grid>
        </>
    }*/

    buttons(){
        let className = this.props.classes.buttons
        if (this.state.isNew){
            className += ' addDevice'
        }
        return <div className={className}>
            <div>
                <ProgressOr showProgress={this.state.network} progressMessage={this.progressMessage()}>
                    {this.cancelButton()}
                    {this.saveButton()}
                </ProgressOr>
            </div>
        </div>
    }

    get deviceTypeConfig() {
        return getDeviceType(this.device.device_type) || {};
    }

    get supportsConnect() {
        return this.deviceTypeConfig.connect === true;
    }

    get supportsMonitor() {
        return this.deviceTypeConfig.monitor !== false;
    }

    get supportsConfiguration() {
        return this.deviceTypeConfig.configuration !== false;
    }

    get canConnect() {
        return this.device.id && this.supportsConnect;
    }

    get hasCreds(){
        const {id, device_type} = this.device
        return id && getDeviceType(device_type)?.cred;
    }

    tabs(admin) {
        return (
            <Tabs value={this.state.open}
                  onChange={(e, val) => this.setState({open: val})}
                  textColor="primary"
                  indicatorColor="primary"
                  variant="fullWidth"
                  className={this.props.classes.tabs}
            >
                <Tab value={0} label="Device info"/>
                <Tab value={1} label="Events" disabled={this.state.isNew}/>
                <Tab value={2} label="Status" disabled={this.state.isNew}/>
                {admin && this.supportsConnect ? <Tab value={3} label="Connect" disabled={!this.canConnect}/> : null}
                {this.supportsMonitor ? <Tab value={4} label="Monitor" disabled={this.state.isNew}  /> : null}
                {this.supportsConfiguration ? <Tab value={5} label="Configuration" disabled={this.state.isNew}  /> : null}
            </Tabs>
        )
    }

    connection(){
        const open = this.state.open === 3
        if (open){
            this.connectionOpened = true
        }
        return <TabPanel hidden={!open}>
            {this.connectionOpened ? <Connection
                deviceId={this.device.id}
                deviceName={this.device.name}
                deviceCode={this.device.code}
            /> : null}
        </TabPanel>
    }

    sounders(){
        const {sounders, installing} = this.state
        if (!this.device.id){
            return null
        }
        return <Grid item xs={12} sm={6} className={this.props.classes.block}>
            <Typography variant="h3">Sounders</Typography>
            <Components
                className={this.props.classes.components}
                components={sounders}
                deviceId={this.device.id}
                title="Sounders"
                typeOptions={SOUNDER_TYPES}
                allocateType={i => `Position ${i}`}
                onModified={async comp => {
                    this.setState({
                        sounders: comp
                    })
                    await this.save(false)
                }}
                onTestCompleted={this.gotSounderTestResults}
                testable={installing}
                typeLabel="Sounder"
                label="sounder"
            />
            {/*{sounders.length ? <Button
                    variant="text"
                    onClick={() => this.setState({
                        installing: !installing
                    })}
                >{installing ? "Finished Install" : "install"}</Button> : null}
            </Components>*/}
        </Grid>
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.state.sounders !== prevState.sounders){
            this.sounderTestResults = mapCompletedTests(this.state.sounders, {})
        }
    }

    deviceModified(){
        const {installing, test_status, isNew} = this.state
        if (test_status === TESTED || isNew){
            return
        }
        const cancel = () => this.setState({
            installing: false
        })
        const unTested = test_status === UNTESTED
        return <Grid item container xs={12} justify="flex-start" direction="row">
            <CheckListDialog
                open={installing}
                variant={unTested ? 'install' : 'manufacture'}
                onDone={async result => {
                   cancel();
                    await this.postedTestResults(result)
                }}
                onCancel={cancel}
            />
            <div className={this.props.classes.deviceModified}>
                <div>
                    <Warning/>
                    <Typography>Device {unTested ? 'Modified' : 'is new'}</Typography>
                </div>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={() => this.setState({installing: true})}
                >Complete Test</Button>
            </div>
        </Grid>
    }

    params(){
        const {device_type, code} = this.state
        switch (device_type){
            case 'VDU':
            case 'MST':
                return `?vehicle_code=${code}`
            case 'PDU':
                return `?pdu_code=${code}`
            default:
                return ''
        }
    }

    documents(){
        return <DocumentsProvider deviceId={this.device.id}>
            <Block heading={<>Documents<UploadDocumentButton deviceId={this.device.id}/></>} fullWidth>
                <DocumentList deviceId={this.device.id}/>
            </Block>
        </DocumentsProvider>
    }

    render(){
        const admin = Rest.isAdmin;
        return (
            <Grid container spacing={2}>
                <Grid item xs={12} container justify="space-between">
                    <Typography variant="h1">{this.device.id ? this.state.name : "Add Device"}</Typography>
                    <Box>
                        {this.device.id && this.hasCreds ? <Credentials classes={this.props.classes} deviceId={this.device.id} deviceName={this.device.name} /> : null}
                        {this.device.id ? <Button
                            endIcon={<Launch/>}hi
                            target="dashboard"
                            href={`/dashboard/${this.state.customer_id}/events/map${this.params()}`}
                            color="primary"
                        >
                            Dashboard
                        </Button> : null}
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Widget>
                        <Grid container spacing={2} className={this.props.classes.crusher}>
                            <Grid item xs={12}>
                                {this.tabs(admin)}
                            </Grid>
                            <Grid item xs={12}>
                                <TabPanel hidden={this.state.open !== 0} className={this.props.classes.infoTab}>
                                    {this.deviceModified()}
                                    {this.basicDetails()}
                                    {this.installation()}
                                    {this.sounders()}
                                    {this.vehicle()}
                                    {this.documents()}
                                    {this.buttons()}
                                </TabPanel>
                                <TabPanel hidden={this.state.open !== 1}>
                                    {this.device.id ?
                                        <DeviceEvents deviceId={this.device.id} deviceName={this.device.name}
                                                      deviceType={this.device.device_type}/> :
                                        null
                                    }
                                </TabPanel>
                                <TabPanel hidden={this.state.open !== 2}>
                                    {this.device.id ?
                                        <DeviceStatus device={this.device} /> :
                                        null
                                    }
                                </TabPanel>
                                {admin && this.device.id && this.supportsConnect ? this.connection() : null}
                                {this.supportsMonitor ? <TabPanel hidden={this.state.open !== 4}>
                                    {this.device.id ?
                                        <Monitor
                                            device={this.device}
                                            setMonitored={async monitored => {
                                                this.device.monitored = monitored;
                                                const json = this.toJson();
                                                this.setState({
                                                    monitored: monitored
                                                })
                                                json.monitored = monitored
                                                await this.send(json)
                                                await this.copyDeviceToCurrentArray()
                                            }}
                                            setOfflineAlert={async hours => {
                                                this.device.offline_alert = hours
                                                const json = this.toJson();
                                                this.setState({
                                                    offline_alert: hours
                                                })
                                                json.offline_alert = hours
                                                await this.send(json)
                                                await this.copyDeviceToCurrentArray()
                                            }}
                                        />  : null
                                    }
                                </TabPanel> : null}
                                {this.supportsConfiguration ? <TabPanel hidden={this.state.open !== 5}>
                                    {this.device.id && this.state.open === 5 ?
                                        <Configuration device={this.device} /> :
                                        null
                                    }
                                </TabPanel> : null}
                            </Grid>
                        </Grid>
                    </Widget>
                </Grid>
            </Grid>
        )
    }
}

export default (props) => {
    const theme = useTheme()
    const classes = useStyles(theme)
    return (
        <Devices.Consumer>
            {devicesContext => (
                <Customers.Consumer>
                    {customersContext => (
                        <EditDevice
                            classes={classes}
                            theme={theme}
                            customersContext={customersContext}
                            devicesContext={devicesContext}
                            {...props}
                        />
                    )}
                </Customers.Consumer>
            )}
        </Devices.Consumer>
    )
}
